import { CompanyTypeEnum } from "@me-team/host/main/graphql/types";

export const BUSINESS_TYPE = {
    SERVICE: CompanyTypeEnum.ServiceBusiness,
    FOOD: CompanyTypeEnum.FoodBusiness,
    OTHER: CompanyTypeEnum.OtherBusiness,
} as const;

export type BusinessType = CompanyTypeEnum;
